import React from 'react';
class Login extends React.Component {

    render() {
        return(
            <div className="row">
                <div className="col-md-8 bg-primary" style={{height: "100vh"}}> IMAGEN </div>
                <div className="col-md-4 bg-info"> FORM</div>
            </div>
        );
    }

}
export default Login;
